import { useEffect, useState } from 'react';
import { NavBar } from '../../../../../themes/components/Navbar';
import { Sidebar } from '../../../../../themes/components/Sidebar';
import { Toaster } from 'react-hot-toast';
import { FooterRelatorios } from '../../../components/FooterRelatorios';
import { VscRunAll } from 'react-icons/vsc';
import { AiOutlineClear } from 'react-icons/ai';
import { Button } from '../../../../../themes/components/Button';
import { useRelatorios } from '../../../../../contexts/Relatorios';
import ReactLoading from 'react-loading';
import { useHistory } from 'react-router-dom';
import { useModals } from '../../../../../contexts/Modals';
import { ContainerRelatorio } from '../../../components/VisualizarRelatorio';
import { ArrayClientes, Cliente } from '../../../../pedidos/interfaces';
import { usePedidos } from '../../../../../contexts/Pedidos';
import { FieldDropdownVer2 } from '../../../../../themes/components/FieldDropdown';

export const RVPE558 = () => {
    const history = useHistory();
    const { mostrarInfoOK } = useModals();
    const { buscarClientes } = usePedidos();
    const { loadingRelatorio, urls, setUrls, gerarRelatorio, setLoadingRelatorio } = useRelatorios();
    const [listaClientes, setListaClientes] = useState<ArrayClientes>();
    const [loadingClientes, setLoadingClientes] = useState<boolean>(false);
    const [fieldCliente, setFieldCliente] = useState<string>("");
    const [codCli, setCodCli] = useState<string>("");
    const [numPedido, setNumPedido] = useState<string>("");

    useEffect(() => {
        setUrls((prevState) => ({
            ...prevState,
            "RVPE558": ""
        }))
        // component unmount 
        return () => {
            setLoadingRelatorio((prevState) => ({
                ...prevState,
                "RVPE558": false
            }))
        }
    }, []);

    function handleChangeCliente(event: any, option: any, reason: any) {
        async function getCliente() {
            await buscarClientes(event.target.value, history)
                .then((res) => {
                    setListaClientes(res);
                    setLoadingClientes(false);
                })
                .catch((err) => {
                    if (err !== "Cancel") {
                        setListaClientes([]);
                        console.log(err);
                        setLoadingClientes(false);
                    }
                })

        }

        if (reason === "input" && event !== null && event.target.value.trim() !== "") {
            if (fieldCliente !== "") {
                setFieldCliente("");
            }
            setLoadingClientes(true);
            getCliente();
            setCodCli(event.target.value.trim());
        }

        if (reason === "reset" && option.trim() !== "") {
            let cod = new RegExp("\\d+", '').exec(option);
            if (cod !== null) {
                setFieldCliente(cod[0]);
            }
        }

        if (reason === "clear" || (event !== null && String(event.target.value).trim() === "")) {
            handleClearFields();
        }
    }

    function getOptionByCod(cod: string) {
        for (let index = 0; listaClientes && index < listaClientes.length; index++) {
            const element = listaClientes[index];
            if (element.codcli === cod) {
                return element;
            }
        }
        return "";
    }

    const handleChangeNumPedido = (event: React.ChangeEvent<{ value: unknown }>) => {
        setNumPedido(event.target.value as string);
    };

    function handleClearFields() {
        setFieldCliente("");
        setCodCli("");
        setNumPedido("");
    }

    function solicitarRelatorio() {
        let objParams: any = [];
        if(fieldCliente !== ""){
            objParams.push({ nome: "CODCLI", valor: fieldCliente })
        }
        if(numPedido !== ""){
            objParams.push({ nome: "NUMPED", valor: numPedido })
        }
        if(fieldCliente == "" && codCli !== ""){
            objParams.push({ nome: "CODCLI", valor: codCli })
        }
        if (objParams.length > 0) {
            setUrls((prevState) => ({
                ...prevState,
                "RVPE558": ""
            }))
            gerarRelatorio("RVPE558", JSON.parse(JSON.stringify(objParams)), history);
        } else {
            setUrls((prevState) => ({
                ...prevState,
                "RVPE558": ""
            }))
            mostrarInfoOK("Número do Pedido ou Código do Cliente precisam ser preenchidos!");
        }
    }

    return (
        <div className="site">
            <Sidebar />
            <div className="main-content">
                <div className="main-content-relatorios">
                    <NavBar />
                    <span className="novo-pedido-title-form">Parâmetros do Relatório</span>
                    <div className="relatorios-campo-busca">
                        <form>
                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="consulta-combobox-tipo-pedido">Código do Cliente</label>
                                    <div className="pedido-linha-campo">
                                        <FieldDropdownVer2
                                            value={getOptionByCod(fieldCliente)}
                                            id="np-combobox-cliente"
                                            options={listaClientes || []}
                                            loading={loadingClientes}
                                            select={(option: Cliente, value: Cliente) => option.codcli === value.codcli}
                                            label={(option: Cliente) => option.codcli !== undefined ? "[" + option.codcli + "] " + option.nomcli : ""}
                                            onChange={(event, option, reason) => handleChangeCliente(event, option, reason)}
                                            noOptionsText={"Digite um código ou nome válido"}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="consulta-combobox-tipo-pedido">Número do Pedido</label>
                                    <div className="pedido-linha-campo">
                                        <input type="text" className="form-control" id="numero-pedido-rel" name="numero-pedido-rel" onChange={handleChangeNumPedido} value={numPedido} />
                                    </div>
                                </div>
                                <div className="form-buttons">
                                    <Button titleText="Gerar relatório" classBtn="" onClick={() => solicitarRelatorio()} >
                                        <VscRunAll color="#444" style={{ marginBottom: '0.3em' }} />
                                    </Button>
                                    <Button titleText="Limpar campos" classBtn="" onClick={() => handleClearFields()} >
                                        <AiOutlineClear color="#444" style={{ marginBottom: '0.3em' }} />
                                    </Button>
                                </div>
                            </div>
                        </form>
                    </div>
                    {loadingRelatorio.RVPE558 === true ?
                        <div className="loading-table-list-pedidos"><ReactLoading type={"bars"} color={"#0252a8"} height={30} width={50} /></div>
                        :
                        urls['RVPE558'] !== "" ?
                            <ContainerRelatorio arquivoUrl={urls['RVPE558']} />
                            : <></>
                    }
                </div>
                <FooterRelatorios funcGerar={() => solicitarRelatorio()} funcImprimir={() => { }} regraGerar={true} regraImprimir={false} />
            </div>
            <Toaster />
        </div>
    )
}